import { useQueryClient } from 'react-query';
import { useAppSocket } from '../../../common/hooks';
import { ProxyServer } from '../entities';
import { ProxyServerAddressesGatewayKeys, ProxyServerConfigurationStatuses } from '../proxyServerAddresses.interfaces';
import { ProxyServersQueryKeys } from '../queries';

interface Data {
  addressId: string;
  proxyServerId: string;
  status: ProxyServerConfigurationStatuses;
  checkedAt: Date | null;
  errorMessage?: string;
}

interface Args {
  proxyServerId: string;
  isProxyServerRequestSuccess: boolean;
  queryClient: ReturnType<typeof useQueryClient>;
}

export const useUpdateProxyServerConf = ({
  proxyServerId,
  isProxyServerRequestSuccess,
  queryClient
}: Args): void => {
  useAppSocket<Data>(ProxyServerAddressesGatewayKeys.UpdateConfigurationStatus, ({ lastMessage }) => {
    if (proxyServerId && isProxyServerRequestSuccess) {
      const { addressId, checkedAt, proxyServerId: serverId, status, errorMessage } = lastMessage;

      queryClient.setQueryData<ProxyServer>([ProxyServersQueryKeys.GetOneById, serverId], (data) => ({
        ...data,
        addresses: data?.addresses.map((address) =>
          address.id === addressId ? ({
            ...address,
            configurationStatus: status,
            configurationStatusError: errorMessage ?? null,
            configurationStatusLastCheckedAt: checkedAt
          }) : address) ?? []
      }) as ProxyServer);
    }
  });
};
